var map = {
	"./number_of_students_csv/da.yml": 395,
	"./number_of_students_csv/en.yml": 396,
	"./photo_session_csv/da.yml": 397,
	"./photo_session_csv/en.yml": 398,
	"./user_elements/da.yml": 399,
	"./user_elements/en.yml": 400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;